// extracted by mini-css-extract-plugin
export default {"root":"summary-module__root__U-1Kd","instantIcon":"summary-module__instantIcon__PsFSD","price":"summary-module__price__gq8a6"};